import { useCallback, useEffect, useState } from "react";
import { getFormName } from "../../../../api/postCall/getFormName";

export interface FormNameState {
  data?: {
    form_name?: string;
  };
  loading?: boolean;
  error?: string;
}
export const useGetFormName = (orderId: string, payerName: string) => {
  const [formNameState, setFormNameState] = useState<FormNameState>({});

  const getFormNameBasedOnOrderId = useCallback(async (orderId: string) => {
    setFormNameState((prev) => ({ ...prev, loading: true }));
    try {
      const response = await getFormName(orderId);
      setFormNameState((prev) => ({
        ...prev,
        data: { form_name: response?.form_name ?? "" },
      }));
    } catch (error) {
      const errorAsString =
        error instanceof Error ? error.message : String(error);
      setFormNameState((prev) => ({ ...prev, error: errorAsString }));
    } finally {
      setFormNameState((prev) => ({ ...prev, loading: false }));
    }
  }, []);

  useEffect(() => {
    if (orderId && payerName) {
      if (checkIfPayerIsOfPriorityHealth(payerName)) {
        getFormNameBasedOnOrderId(orderId);
      }
    }
  }, [orderId, payerName, getFormNameBasedOnOrderId]);

  return {
    formNameState,
  };
};

const checkIfPayerIsOfPriorityHealth = (payerName: string) => {
  return payerName.toLowerCase().includes("priority health");
};
